import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import DimensionRange from './DimensionRange';
import DistortionDimensionRange from './DistortionDimensionRange';
import ArrayUtil from '../../../utils/ArrayUtil';

class BehaviorBenchmarks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: ['behavior'],
    };
  }

  render() {
    const {
      benchmarks, distortionBenchmark, isEdit, onChange, hintsCS, hintsJPS, hintsSJL,
    } = this.props;
    const { expanded } = this.state;
    // get concurrent study hints
    const csBenchmarks = ArrayUtil.isNotEmpty(hintsCS) ? hintsCS : [];

    // get job profile survey hints
    const jpsBenchmarks = ArrayUtil.isNotEmpty(hintsJPS) ? hintsJPS : [];

    // get standard job hints
    const sjlBenchmarks = (hintsSJL && ArrayUtil.isNotEmpty(hintsSJL.behaviorStandardJobBenchmarks))
      ? hintsSJL.behaviorStandardJobBenchmarks
      : [];
    if (!benchmarks || ArrayUtil.isEmpty(benchmarks.dimensionBenchmarks)) return null;

    let { dimensionBenchmarks } = benchmarks;
    dimensionBenchmarks = dimensionBenchmarks.slice();
    dimensionBenchmarks = dimensionBenchmarks.map(d => ({
      dimensionRange: d,
      hintCSRange: csBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintJPSRange: jpsBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintSJLRange: sjlBenchmarks.filter(h => h.dimensionName === d.code)[0],
    }));
    return (
      <div className="accordion-legacy-container">
        <Accordion preExpanded={expanded} allowZeroExpanded>
          <AccordionItem uuid="behavior">
            <AccordionItemHeading>
              <AccordionItemButton>
                <span className="t-large">{benchmarks.displayName}</span>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="accordion-panel">
              <div className="abilityContainer">
                {dimensionBenchmarks.map(d => (
                  <DimensionRange
                    key={`${d.dimensionRange.code}`}
                    dimensionRange={d.dimensionRange}
                    hintCSRange={d.hintCSRange}
                    hintJPSRange={d.hintJPSRange}
                    hintSJLRange={d.hintSJLRange}
                    isEdit={isEdit}
                    onChange={(...rest) => onChange(...rest, 'behaviorBenchmarks')}
                  />
                ))}
                <DistortionDimensionRange
                  key={`${distortionBenchmark.code}`}
                  dimensionRange={distortionBenchmark}
                />
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    );
  }
}

BehaviorBenchmarks.propTypes = {
  benchmarks: PropTypes.objectOf(PropTypes.any).isRequired,
  distortionBenchmark: PropTypes.objectOf(PropTypes.any).isRequired,
  isEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  hintsCS: PropTypes.arrayOf(PropTypes.any),
  hintsJPS: PropTypes.arrayOf(PropTypes.any),
  hintsSJL: PropTypes.arrayOf(PropTypes.any),
};

BehaviorBenchmarks.defaultProps = {
  hintsCS: [],
  hintsJPS: [],
  hintsSJL: [],
};

export default BehaviorBenchmarks;
